import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, TaskFormValuesModel, EntityModel, ResponseValidateInfoModel, DeviceHierarchyModel, TaskModel, FileModel, SaveFileModel, LocationEquipmentModel, FormValuesModel, TaskStatusModel, ResponseDeleteModel, TaskStatusChangeModel, ResponseListModel, PaymentsModel} from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'

export interface ITasksService {
    getTasks(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    createTask(req): ng.IPromise<any>
    createMassTask(req): ng.IPromise<any>
    deleteTask(id): ng.IPromise<ResponseDeleteModel>
    getTask(id, state?: any): ng.IPromise<TaskModel>
    getTaskToEdit(id, state?: any): ng.IPromise<EntityModel>
    getAttachments(id, state?: any): ng.IPromise<ResponseListModel<FileModel>>
    getEquipment(id, state?: any): ng.IPromise<ResponseListModel<LocationEquipmentModel>>
    checkIfAttachmentExists(id, attachmentId): ng.IPromise<string>
    saveAttachment(attachment: FileModel): ng.IPromise<SaveFileModel>
    deleteAttachments(model: FormValuesModel): ng.IPromise<ResponseListModel<number>>
    getAvailableStatuses(ids: number[], state?: any): ng.IPromise<ResponseListModel<TaskStatusModel>>
    saveStatuses(model: TaskStatusChangeModel): ng.IPromise<ResponseListModel<TaskModel>>
    getTaskPayments(id, state?: any): ng.IPromise<ResponseListModel<PaymentsModel>>
    validateTasks(model, state?: any): ng.IPromise<ResponseValidateInfoModel>
}

export class TasksService implements ITasksService {
    constructor(private apiResource: ApiResourceFactory) {

    }

    getTasks(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.tasks.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getTask(id, state: any = {}) {
        var get = this.apiResource.tasks.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    getTaskToEdit(id, state: any = {}) {
        var getTaskToEdit: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.tasks['getTaskToEdit']
        state.request = getTaskToEdit({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    validateTasks(model: TaskFormValuesModel) {
        return this.apiResource.tasks['validate'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    createTask(req) {
        return this.apiResource.tasks.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => {
            CommonHelper.goToLoginPage(this.apiResource, rej.status)
        })
    }

    createMassTask(req) {
        return this.apiResource.tasks.save(req).$promise.then(result => {
            return (<any>result).toJSON()
        }).catch(rej => {
            CommonHelper.goToLoginPage(this.apiResource, 0)
        })
    }

    deleteTask(id): ng.IPromise<ResponseDeleteModel> {
        return this.apiResource.tasks.delete({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getAttachments(id, state: any = {}) {
        var getAttachments: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<FileModel>>> = this.apiResource.tasks['getAttachments']
        state.request = getAttachments({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getEquipment(id, state: any = {}) {
        var getEquipment: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<LocationEquipmentModel>>> = this.apiResource.tasks['getEquipment']
        state.request = getEquipment({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    checkIfAttachmentExists(id, attachmentId):ng.IPromise<string> {
        var checkIfExists: ng.resource.IResourceMethod<ng.resource.IResource<string>> = this.apiResource.tasks['checkIfAttachmentExists']
        return checkIfExists({ id: id, attachmentId: attachmentId }).$promise.then(r => {
            var result = ""
            var rJSON = (<any>r).toJSON()
            for (var i in rJSON) {
                result += rJSON[i]
            }
            return result
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    saveAttachment(attachment: FileModel): ng.IPromise<SaveFileModel> {
        var saveAttachment: ng.resource.IResourceMethod<ng.resource.IResource<SaveFileModel>> = this.apiResource.tasks['saveAttachment']
        return saveAttachment(attachment).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    deleteAttachments(model: FormValuesModel): ng.IPromise<ResponseListModel<number>> {
        var deleteAttachment: ng.resource.IResourceMethod<ng.resource.IResource<ResponseListModel<number>>> = this.apiResource.tasks['deleteAttachment']
        return deleteAttachment(model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getAvailableStatuses(ids: number[], state: any = {}) {
        var get = this.apiResource.tasks['getAvailableStatuses']
        state.request = get(ids)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    saveStatuses(model: TaskStatusChangeModel) {
        var save = this.apiResource.tasks['saveTaskStatuses']
        return save(model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getTaskPayments(id: number, state: any = {}) {
        var payments = this.apiResource.tasks['getTaskPayments']        
        return payments({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
}

